import styled from 'styled-components/native'
import styledReact from 'styled-components'
import { Constants } from '@sukiai/components'
import { casal, whiteSmoke } from '@sukiai/components/lib/colors'
import playButton from '../../lib/assets/icons/white-play-button.svg'

const { ICON_SIZE } = Constants

export const SkipButton = styled.Text`
  position: absolute;
  right: 5px;
  bottom: 7%;
  border: 1px solid ${casal};
  padding: 10px;
  width: 100px;
  textAlign: center;
  color: ${casal};
  font-size: 12pt;
  opacity: 0.75;
  display: ${props => props.isvisible === 'true'
    ? 'none'
    : 'block'
};
`

export const NextButton = styled.Text`
  position: absolute;
  right: 40px;
  border: 1px solid ${casal};
  padding: 10px;
  textAlign: center;
  color: ${casal};
  font-size: 12pt;
  opacity: 0.75;
  bottom: 2%;
  width: 150px;
`

export const CloseButton = styled.Text`
  border: 1px solid ${whiteSmoke};
  border-radius: 2px;
  padding: 0 10px;
  text-align: center;
  line-height: 35px;
  color: ${whiteSmoke};
  font-size: 10pt;
  position: absolute;
  top: 0;
  right: -6%;
  cursor: ${props => props.isclosebuttonhovered === 'true'
    ? 'pointer'
    : 'auto'
};
`

export const PlayerContainer = styled.Text`
  position: absolute;
  width: 88%;
  top: 0.5%;
  left: 5%;
  height: 40%;
  z-index: 10001;
  display: ${props => props.shouldvideoplayershowandplay === 'true'
    ? 'block'
    : 'none'
};
`

export const PlayButtonContainer = styled.View`
  margin-top: 5%;
  margin-left: 33.3%;
`

export const PlayButtonIcon = styledReact.img.attrs({
  src: playButton,
  height: ICON_SIZE.XLARGE,
  width: ICON_SIZE.XLARGE
})`
`

export const MainContainer = styled.View`
  position: relative;
  height: 99%;
  font-family: 'Lato, sans-serif';
  font-weight: 300;
  z-index: ${props => props.isvideoplaying === 'true'
    ? '10000'
    : '10'
};
`
